import { render, staticRenderFns } from "./WrongPage.vue?vue&type=template&id=2ab4d28e&scoped=true"
import script from "./WrongPage.vue?vue&type=script&lang=ts"
export * from "./WrongPage.vue?vue&type=script&lang=ts"
import style0 from "./WrongPage.vue?vue&type=style&index=0&id=2ab4d28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4d28e",
  null
  
)

export default component.exports